/* eslint-disable indent */
/***
 * 模块信息的配置文件，通过模块的dataType作为key
 * 配置模块的以下信息
 * @moduleName 模块名称
 * @moduleId 模块id
 * @microName 微前端名称，如果没配置，该模块默认属于基础的微前端 - eh-core
 * ***/
const modulesConfig = {
	'payment-management': {
		moduleName: '物业缴费',
		moduleId: 20400,
		microName: 'eh-asset',
	},
	'property-repair': {
		moduleName: '物业报修',
		moduleId: 20100,
		microName: 'eh-park',
	},
	'forum-management': {
		moduleName: '园区论坛',
		moduleId: 10100,
		microName: 'eh-park',
	},
	'notice-management': {
		moduleName: '园区公告',
		moduleId: 10300,
		microName: 'eh-park',
	},
	'advert-management': {
		moduleName: '园区广告',
		moduleId: 10400,
		microName: 'eh-park',
	},
	'activity-application': {
		moduleName: '园区活动',
		moduleId: 10600,
		microName: 'eh-park',
	},
	'service-alliance': {
		moduleName: '服务联盟',
		moduleId: 40500,
		microName: 'eh-park',
	},
	'resource-booking': {
		moduleName: '资源预订',
		moduleId: 40400,
		microName: 'eh-park',
	},
	'park-news': {
		moduleName: '园区快讯',
		moduleId: 10800,
		microName: 'eh-park',
	},
	'decoration-management': {
		moduleName: '装修办理',
		moduleId: 43000,
		microName: 'eh-park',
	},
	'cloud-print': {
		moduleName: '园区云打印',
		moduleId: 41400,
		microName: 'eh-park',
	},

	'goods-move': {
		moduleName: '物品放行',
		moduleId: 49200,
		microName: 'eh-park',
	},
	'questionnaire-survey': {
		moduleName: '问卷调查',
		moduleId: 41700,
		microName: 'eh-park',
	},
	'service-online': {
		moduleName: '客服热线',
		moduleId: 40300,
		microName: 'eh-park',
	},
	'policy-declaration': {
		moduleName: '政策申报',
		moduleId: 286600,
		microName: 'eh-park',
	},
	'park-map': {
		moduleName: '园区地图',
		moduleId: 288500,
		microName: 'eh-park',
	},
	'forum-circle': {
		moduleName: '论坛管理',
		moduleId: 288600,
		microName: 'eh-park',
	},
	'policy-service': {
		moduleName: '政务服务',
		moduleId: 41900,
		microName: 'eh-park',
	},
	'bus-guard': {
		moduleName: '园区班车',
		moduleId: 41015,
		microName: 'eh-park',
	},
	'gzyx-asset-mgt': {
		moduleName: '空间资产管理',
		moduleId: 285700,
		microName: 'eh-park',
	},
	'lgct-vr-watching': {
		moduleName: 'VR全景看房',
		moduleId: 288800,
		microName: 'eh-park',
	},
	'ya-institution-settle': {
		moduleName: '机构入驻',
		moduleId: 289200,
		microName: 'eh-park',
	},
	'ya-project-management': {
		moduleName: '研发项目管理服务',
		moduleId: 289500,
		microName: 'eh-park',
	},
	'club-management': {
		moduleName: '俱乐部',
		moduleId: 10750,
		microName: 'eh-park',
	},

	'station-booking': {
		moduleName: '孵化器管理',
		moduleId: 40200,
		microName: 'eh-park',
	},
	'user-identification': {
		moduleName: '用户认证',
		moduleId: 35000,
		microName: 'eh-core',
	},
	'ec-delivery-service': {
		moduleName: '配送管理',
		moduleId: 284000,
		microName: 'eh-ecommerce',
	},
	'ec-store-mng': {
		moduleName: '店铺管理',
		moduleId: 283800,
		microName: 'eh-ecommerce',
	},
	'ec-mall-management': {
		moduleName: '微商城管理',
		moduleId: 283900,
		microName: 'eh-ecommerce',
	},
	'delivery-service': {
		moduleName: '配送管理',
		moduleId: 280700,
		microName: 'eh-ecommerce',
	},
	'ad-mgt': {
		moduleName: '广告管理',
		moduleId: 286700,
		microName: 'eh-promotion',
	},
	'deposit-management': {
		moduleName: '储值管理',
		moduleId: 290600,
		microName: 'eh-promotion',
	},
	'company-deposit': {
		moduleName: '企业储值账户',
		moduleId: 290700,
		microName: 'eh-promotion',
	},
	'invoice-center': {
		moduleName: '发票中心',
		moduleId: 282700,
		microName: 'eh-promotion',
	},
	'business-merchant': {
		moduleName: '收款商户',
		moduleId: 283000,
		microName: 'eh-promotion',
	},
	'business-merchant-mkt': {
		moduleName: '促销管理',
		moduleId: 284700,
		microName: 'eh-promotion',
	},
	'coupon-center': {
		moduleName: '领卷中心',
		moduleId: 285900,
		microName: 'eh-promotion',
	},
	'integral-management': {
		moduleName: '积分管理',
		moduleId: 47000,
		microName: 'eh-promotion',
	},
	'integral-bank': {
		moduleName: '积分银行',
		moduleId: 4800,
		microName: 'eh-promotion',
	},
	'business-operation': {
		moduleName: '商户运营',
		moduleId: 279800,
		microName: 'eh-promotion',
	},
	'write-offs': {
		moduleName: '流水核销',
		moduleId: 292400,
		microName: 'eh-promotion',
	},
	'business-account': {
		moduleName: '客户余额账户',
		moduleId: 295500,
		microName: 'eh-promotion',
	},
	'company-member': {
		moduleName: '企业会员',
		moduleId: 282800,
		microName: 'eh-promotion',
	},
	'marketing-statistics': {
		moduleName: '营销统计',
		moduleId: 283100,
		microName: 'eh-promotion',
	},
	'platform-merchant-mkt': {
		moduleName: '平台商户营销',
		moduleId: 284600,
		microName: 'eh-promotion',
	},
	'individual-member': {
		moduleName: '个人会员',
		moduleId: 289700,
		microName: 'eh-promotion',
	},
	'split-management': {
		moduleName: '商户管理',
		moduleId: 287000,
		microName: 'eh-promotion',
	},
	'physical-card-management': {
		moduleName: '实体卡管理',
		moduleId: 291300,
		microName: 'eh-promotion',
	},
	'device-management': {
		moduleName: '设备运维',
		moduleId: 282400,
		microName: 'eh-property',
	},
	'fire-alarm-baoye': {
		moduleName: '消防告警',
		moduleId: 284800,
		microName: 'eh-property',
	},
	'property-inspection': {
		moduleName: '综合巡更',
		moduleId: 281300,
		microName: 'eh-property',
	},
	'yh-rectification-notice': {
		moduleName: '整改通知单管理',
		moduleId: 288100,
		microName: 'eh-property',
	},
	'safety-check': {
		moduleName: '安全检查',
		moduleId: 283300,
		microName: 'eh-property',
	},
	'equipment-monitor': {
		moduleName: '设备监控',
		moduleId: 290900,
		microName: 'eh-property',
	},
	'quality-inspect': {
		moduleName: '品质核查',
		moduleId: 20600,
		microName: 'eh-property',
	},
	'equipment-management': {
		moduleName: '物业巡检',
		moduleId: 20800,
		microName: 'eh-property',
	},
	'store-management': {
		moduleName: '仓库管理',
		moduleId: 21000,
		microName: 'eh-property',
	},
	'supplier-management': {
		moduleName: '供应商管理',
		moduleId: 27000,
		microName: 'eh-property',
	},
	'energy-management': {
		moduleName: '能耗管理',
		moduleId: 49100,
		microName: 'eh-property',
	},
	'building-auto': {
		moduleName: 'BA智能',
		moduleId: 292200,
		microName: 'eh-property',
	},
	'gas-monitor': {
		moduleName: '燃气监控',
		moduleId: 292100,
		microName: 'eh-property',
	},
	'real-weather': {
		moduleName: '实时气象',
		moduleId: 303800,
		microName: 'eh-property',
	},
	'public-transfer': {
		moduleName: '企业账单',
		moduleId: 20500,
		microName: 'eh-asset',
	},
	'contract-management': {
		moduleName: '合同管理',
		moduleId: 21200,
		microName: 'eh-asset',
	},
	'permanent-asset': {
		moduleId: 59000,
		moduleName: '固定资产管理',
		microName: 'eh-asset',
	},
	'shunshun-collection': {
		moduleId: 289000,
		moduleName: '顺顺管家企业收款',
		microName: 'eh-asset',
	},
	'asset-management': {
		moduleName: '空间资产管理',
		moduleId: 38000,
		microName: 'eh-asset',
	},
	'customer-management': {
		moduleName: '企业客户管理',
		moduleId: 21100,
		microName: 'eh-asset',
	},
	'requisition-management': {
		moduleName: '请示单管理',
		moduleId: 25000,
		microName: 'eh-asset',
	},
	'investment-ad': {
		moduleName: '房源发布',
		moduleId: 150010,
		microName: 'eh-asset',
	},
	'business-invitation': {
		moduleName: '招商管理',
		moduleId: 150020,
		microName: 'eh-asset',
	},
	'individual-customer': {
		moduleName: '个人客户管理',
		moduleId: 37000,
		microName: 'eh-asset',
	},
	'crm-management': {
		moduleName: '客户管理',
		moduleId: 282000,
		microName: 'eh-asset',
	},
	'property-statistic': {
		moduleName: '资产管理报表',
		moduleId: 230000,
		microName: 'eh-asset',
	},
	'business-management': {
		moduleName: '旧商户管理',
		moduleId: 210000,
		microName: 'eh-asset',
	},
	'sales-opportunity': {
		moduleName: '商机管理',
		moduleId: 280400,
		microName: 'eh-asset',
	},
	'financial-vouchers': {
		moduleName: '凭证中心',
		moduleId: 281400,
		microName: 'eh-asset',
	},
	'investment-strategy': {
		moduleName: '招商策略',
		moduleId: 286800,
		microName: 'eh-asset',
	},
	'apply-admission': {
		moduleName: '入园申请',
		moduleId: 286900,
		microName: 'eh-asset',
	},
	'hetian-booth': {
		moduleName: '和田摊位管理',
		moduleId: 283700,
		microName: 'eh-asset',
	},
	'yuehai-ioc': {
		moduleName: '粤海数字驾驶舱',
		moduleId: 290000,
		microName: 'eh-datav',
	},
	'big-data-monitoring': {
		moduleName: '运营指挥中心',
		moduleId: 283200,
		microName: 'eh-datav',
	},
	'hetian-ioc': {
		moduleName: '和田IOC系统管理',
		moduleId: 286400,
		microName: 'eh-datav',
	},
	'report-center': {
		moduleName: '数据报表中心',
		moduleId: 281100,
		microName: 'eh-datav',
	},
	'data-configuration': {
		moduleName: '数据配置中心',
		moduleId: 292000,
		microName: 'eh-datav',
	},
	'company-access': {
		moduleName: '企业门禁',
		moduleId: 41120,
		microName: 'eh-aclink',
	},
	'company-monitor': {
		moduleName: '企业视频监控',
		moduleId: 282100,
		microName: 'eh-aclink',
	},
	'office-iclink': {
		moduleName: '办公智控',
		moduleId: 288200,
		microName: 'eh-aclink',
	},
	'public-monitor': {
		moduleName: '公共视频监控',
		moduleId: 282200,
		microName: 'eh-aclink',
	},
	'public-access': {
		moduleName: '公共门禁',
		moduleId: 41110,
		microName: 'eh-aclink',
	},
	'park-iclink': {
		moduleName: '园区智控',
		moduleId: 289900,
		microName: 'eh-aclink',
	},
	'yaj-access-control': {
		moduleName: '人员通行管理',
		moduleId: 286000,
		microName: 'eh-aclink',
	},
	'organization-structure': {
		moduleName: '组织架构',
		moduleId: 50100,
		microName: 'eh-core',
	},
	'address-book': {
		moduleName: '通讯录',
		moduleId: 50100,
		microName: 'eh-core',
	},
	'employee-identification': {
		moduleName: '员工认证',
		moduleId: 50500,
		microName: 'eh-core',
	},
	'time-schedule': {
		moduleName: '日程',
		moduleId: 59100,
		microName: 'eh-core',
	},
	'enterprise-wallet': {
		moduleName: '企业钱包',
		moduleId: 59200,
		microName: 'eh-core',
	},
	'visitor-enterprise': {
		moduleName: '企业访客',
		moduleId: 52100,
		microName: 'eh-core',
	},
	'task-management': {
		moduleName: '任务监控',
		moduleId: 13000,
		microName: 'eh-core',
	},
	'my-task': {
		moduleName: '我的任务',
		moduleId: 50100,
		microName: 'eh-core',
	},
	'flow-control': {
		moduleName: '流程跟踪',
		moduleId: 298500,
		microName: 'eh-core',
	},
	'work-order-management': {
		moduleName: '工单管理',
		moduleId: 297100,
		microName: 'eh-core',
	},
	'customer-info': {
		moduleName: '企业信息',
		moduleId: 21400,
		microName: 'eh-core',
	},
	'seal-management': {
		moduleName: '印章管理',
		moduleId: 288300,
		microName: 'eh-core',
	},
	'salary-management': {
		moduleName: '薪酬管理',
		moduleId: 51400,
		microName: 'eh-core',
	},
	'social-security': {
		moduleName: '社保管理',
		moduleId: 51300,
		microName: 'eh-core',
	},
	'message-push': {
		moduleName: '一键推送',
		moduleId: 11000,
		microName: 'eh-core',
	},
	'user-management': {
		moduleName: '用户管理',
		moduleId: 34000,
		microName: 'eh-core',
	},
	'mini-program-mgt': {
		moduleName: '小程序码管理',
		moduleId: 284400,
		microName: 'eh-core',
	},
	'zuolin-unit-code': {
		moduleName: '社区码管理',
		moduleId: 287100,
		microName: 'eh-core',
	},
	'runchuang-demolition': {
		moduleName: '拆迁管理',
		moduleId: 285800,
		microName: 'eh-vdocking',
	},
	'yczgc-haikang': {
		moduleName: '海康管理平台',
		moduleId: 286300,
		microName: 'eh-vdocking',
	},
	'huihuating-demolition': {
		moduleName: '惠华庭拆迁管理',
		moduleId: 290200,
		microName: 'eh-vdocking',
	},
	'donghu-maintain': {
		moduleName: '东湖报事报修',
		moduleId: 287200,
		microName: 'eh-vdocking',
	},
	'cangshan-subdistrict-ranking': {
		moduleName: '镇街工作排名',
		moduleId: 284900,
		microName: 'eh-vdocking',
	},
	'cangshan-comp-benefit': {
		moduleName: '惠企政策及兑现',
		moduleId: 285000,
		microName: 'eh-vdocking',
	},
	'cangshan-comp-info': {
		moduleName: '企业信息管理',
		moduleId: 285100,
		microName: 'eh-vdocking',
	},
	'cangshan-investment-mgt': {
		moduleName: '招商项目管理',
		moduleId: 285400,
		microName: 'eh-vdocking',
	},
	'cangshan-state-asset': {
		moduleName: '国有资产管理',
		moduleId: 285500,
		microName: 'eh-vdocking',
	},
	'yaj-parking': {
		moduleName: '云安居停车管理',
		moduleId: 286500,
		microName: 'eh-vdocking',
	},
	'donghu-cam': {
		moduleName: '东湖之眼',
		moduleId: 287300,
		microName: 'eh-vdocking',
	},
	'donghu-feedback': {
		moduleName: '东湖意见反馈',
		moduleId: 287500,
		microName: 'eh-vdocking',
	},
	'donghu-public-transport': {
		moduleName: '公共交通查询',
		moduleId: 287700,
		microName: 'eh-vdocking',
	},
	'donghu-recycle': {
		moduleName: '垃圾分类',
		moduleId: 287800,
		microName: 'eh-vdocking',
	},
	'donghu-equipment': {
		moduleName: '东湖公共设施',
		moduleId: 287900,
		microName: 'eh-vdocking',
	},
	'yh-risk-assessment': {
		moduleName: '入园风险评估',
		moduleId: 288000,
		microName: 'eh-vdocking',
	},
	'vehicle-move': {
		moduleName: '一键挪车',
		moduleId: 288700,
		microName: 'eh-vdocking',
	},
	'cangshan-industry': {
		moduleName: '智慧产业管理',
		moduleId: 288900,
		microName: 'eh-vdocking',
	},
	'dh-community-prevention': {
		moduleName: '社区防疫申报',
		moduleId: 289600,
		microName: 'eh-vdocking',
	},
	'parking-payment': {
		moduleName: '停车缴费',
		moduleId: 40800,
		microName: 'eh-parking',
	},
	'vehicle-release': {
		moduleName: '车辆放行',
		moduleId: 20900,
		microName: 'eh-parking',
	},
	'parking-record': {
		moduleName: '停车出入记录',
		moduleId: 290800,
		microName: 'eh-parking',
	},
	'blacklist-management': {
		moduleName: '黑名单管',
		moduleId: 30600,
		microName: 'eh-core',
	},
	'community-intro': {
		moduleName: '项目介绍',
		moduleId: 281500,
		microName: 'eh-core',
	},
	'enterprise-management': {
		moduleName: '企业管理',
		moduleId: 33000,
		microName: 'eh-core',
	},
	'suggestion-feedback': {
		moduleName: '意见反馈',
		moduleId: 285600,
		microName: 'eh-core',
	},
	'gangwan-apartment-apply': {
		moduleName: '人才公寓',
		moduleId: 281700,
		microName: 'eh-core',
	},
	'ncp-management': {
		moduleName: '疫情管理',
		moduleId: 283600,
		microName: 'eh-core',
	},
	'payment-on-account': {
		moduleName: '挂账管理',
		moduleId: 280900,
		microName: 'eh-core',
	},
	'platform-merchant': {
		moduleName: '平台商户',
		moduleId: 282900,
		microName: 'eh-core',
	},
	'popup-adv-ruian': {
		moduleName: '瑞安弹窗告',
		moduleId: 282300,
		microName: 'eh-core',
	},
	'report-management': {
		moduleName: '举报管理',
		moduleId: 51000,
		microName: 'eh-core',
	},
	'startup-advert': {
		moduleName: '启动广告',
		moduleId: 10900,
		microName: 'eh-core',
	},
	'user-profile': {
		moduleName: '用户档案理',
		moduleId: 287600,
		microName: 'eh-core',
	},
	'enterprise-notice': {
		moduleName: '企业公告',
		moduleId: 57000,
		microName: 'eh-oa',
	},
	'notice-work': {
		moduleName: '企业公告',
		moduleId: 57000,
		microName: 'eh-oa',
	},
	'employee-record': {
		moduleName: '人事档案',
		moduleId: 50400,
		microName: 'eh-oa',
	},
	'approval-management': {
		moduleName: '流程审批',
		moduleId: 52000,
		microName: 'eh-oa',
	},
	'approval-work': {
		moduleName: '流程审批',
		moduleId: 52000,
		microName: 'eh-oa',
	},
	'attendance-management': {
		moduleName: '打卡考勤',
		moduleId: 50600,
		microName: 'eh-oa',
	},
	'work-report': {
		moduleName: '工作汇报',
		moduleId: 54000,
		microName: 'eh-oa',
	},
	'working-conference': {
		moduleName: '工作汇报',
		moduleId: 54000,
		microName: 'eh-oa',
	},
	'meeting-management': {
		moduleName: '会议管理',
		moduleId: 53000,
		microName: 'eh-oa',
	},
	'meeting-work': {
		moduleName: '会议管理',
		moduleId: 53000,
		microName: 'eh-oa',
	},
	'document-management': {
		moduleName: '文档管理',
		moduleId: 55000,
		microName: 'eh-oa',
	},
	'document-work': {
		moduleName: '文档管理',
		moduleId: 55000,
		microName: 'eh-oa',
	},
	'enterprise-welfare': {
		moduleName: '企业福利',
		moduleId: 273000,
		microName: 'eh-oa',
	},
	'enterprise-payment-auth': {
		moduleName: '企业支付授权',
		moduleId: 271000,
		microName: 'eh-oa',
	},
	'visitor-park': {
		moduleName: '园区访客',
		moduleId: 41800,
		microName: 'eh-aclink',
	},
	'project-manager': {
		moduleName: '项目管理',
		moduleId: 290300,
		microName: 'eh-qz',
	},
	'archives-management': {
		moduleName: '居民档案管理',
		moduleId: 291000,
		microName: 'eh-qz',
	},
	'community-escrow': {
		moduleName: '学生托管',
		moduleId: 290400,
		microName: 'eh-qz',
	},
	'communitgrid-management': {
		moduleName: '网格管理',
		moduleId: 290500,
		microName: 'eh-qz',
	},
	'user-behavior': {
		moduleName: '用户行为统计',
		moduleId: 41330,
		microName: 'eh-core',
	},
	'application-statistic': {
		moduleName: '用户活跃统计',
		moduleId: 41300,
		microName: 'eh-core',
	},
	'access-control': {
		moduleName: '老公共门禁',
		moduleId: 41010,
		microName: 'eh-aclink',
	},
	'parking-discount': {
		moduleName: '停车优惠',
		moduleId: 280100,
		microName: 'eh-parking',
	},
	'data-report-center': {
		moduleName: '数据报表中心',
		moduleId: 291100,
		microName: 'eh-datav',
	},
	'one-card': {
		moduleName: '第三方钱包',
		moduleId: 41200,
		microName: 'eh-park',
	},
	'szbay-ind-map': {
		moduleName: '深圳湾产业图谱',
		moduleId: 291100,
		microName: 'eh-asset',
	},
	'asset-management-ledger': {
		moduleName: '空间资产管理台账',
		moduleId: 38100,
		microName: 'eh-asset',
	},
	'ytport-datareport': {
		moduleName: '盐田港定制报表',
		moduleId: 293400,
		microName: 'eh-asset',
	},
	'complaints-management': {
		moduleName: '投诉建议',
		moduleId: 292300,
		microName: 'eh-park',
	},
	'collection-management': {
		moduleName: '托收管理',
		moduleId: 292900,
		microName: 'eh-promotion',
	},
	'collection-list': {
		moduleName: '托收列表',
		moduleId: 292900,
		microName: 'eh-promotion',
	},
	'collection-contracts': {
		moduleName: '托收协议',
		moduleId: 292900,
		microName: 'eh-promotion',
	},
	'rp-wk': {
		moduleName: '周汇报管理',
		moduleId: 293600,
		microName: 'eh-vdocking',
	},
	'Vy-pc-comp': {
		moduleName: '企业数据管理',
		moduleId: 294900,
		microName: 'eh-vdocking',
	},
	'Wy-mglist': {
		moduleName: '在管项目数据',
		moduleId: 299100,
		microName: 'eh-vdocking',
	},
	'receipt-center': {
		moduleName: '收据中心',
		moduleId: 293700,
		microName: 'eh-promotion',
	},
	'ec-management': {
		moduleName: '水电管理',
		moduleId: 293800,
		microName: 'eh-property',
	},
	'park-environment': {
		moduleName: '园区环境控制',
		moduleId: 297200,
		microName: 'eh-property',
	},
	'office-environment': {
		moduleName: '办公环境控制',
		moduleId: 297300,
		microName: 'eh-property',
	},
	'disburse-management': {
		moduleName: '付款管理',
		moduleId: 299000,
		microName: 'eh-asset',
	},
	'equipment-linkage': {
		moduleName: '联动中心',
		moduleId: 299700,
		microName: 'eh-property'
	},
	'tip-billcenter': {
		moduleName: 'TIP+账单中心',
		moduleId: 301000,
		microName: 'eh-vdocking'
	},
	'corporate-certification': {
		moduleName: '对公认证',
		moduleId: 300400,
		microName: 'eh-promotion',
	},
	'equipment-scene': {
		moduleName: '情景中心',
		moduleId: 299800,
		microName: 'eh-property'
	},
	'pay-contract-management': {
		moduleName: '返租合同',
		moduleId: 299400,
		microName: 'eh-asset',
	},
	'fixed-asset': {
		moduleName: '固定资产管理',
		moduleId: 301700,
		microName: 'eh-oa',
	},
	'traffic-analvsis': {
		moduleName: '人流量统计',
		moduleId: 301800,
		microName: 'eh-property'
	},
    'renovation-management': {
		moduleName: '装修管理',
		moduleId: 300600,
		microName: 'eh-park',
	},
    'renovation-application': {
		moduleName: '装修申请',
		moduleId: 300700,
		microName: 'eh-park',
	},
	'charging-station': {
		moduleName: '充电桩预约',
		moduleId: 303500,
		microName: 'eh-property'
	},
	'device-management-new': {
		moduleName: '设备管理',
		moduleId: 305100,
		microName: 'eh-property'
	},
	'energy-quota': {
		moduleName: '能耗定额与告警',
		moduleId: 305300,
		microName: 'eh-property'
	},
	'energy-tuning': {
		moduleName: '节能调优',
		moduleId: 305200,
		microName: 'eh-property'
	},
	'equipment-diagram': {
		moduleName: '设备组态',
		moduleId: 305500,
		microName: 'eh-property'
	},
	'truck-management': {
		moduleName: '货车放行',
		moduleId: 305700,
		microName: 'eh-parking'
	},
};

export default modulesConfig;
